// extracted by mini-css-extract-plugin
export default {"container":"LatestEvent_container__FWKyw","row":"LatestEvent_row__Mpil3","label":"LatestEvent_label__e+jlr","text":"LatestEvent_text__IJcN5"};